import { init } from '@indeed/frontend-logging';
// @ts-ignore
import { JSErrorModule } from '@indeed/frontend-logging/modules/jsError';
import { SignalsErrorTransport, SignalsErrorTransportOptions } from './signalsTransport';

export interface SignalsErrorLoggerConfig {
    pageLoadTk: string;
    priorJsErrors: any[];
}

const initializeSignalsErrorLogger = (config: SignalsErrorLoggerConfig) => {
    const logger = init({
        application: 'messaging-webapp',
        modules: ['jsError'],
        moduleOptions: {
            jsError: {
                priorJsErrors: config.priorJsErrors,
            },
        },
    });
    logger.setModules([JSErrorModule]);
    const signalsErrorTransportOptions: SignalsErrorTransportOptions = {
        parenttk: config.pageLoadTk,
    };
    logger.setTransport(SignalsErrorTransport, signalsErrorTransportOptions);

    return logger;
};

export { initializeSignalsErrorLogger };
